(function (app) {

    app.constant("transactionStatus",
    {
        continue:
            [
                { Label: "In Progress", Value: "InProgress" },
            ],
        locked:
            [
                { Label: "Cancelled", Value: "Cancelled" },
                { Label: "Submitted To Firelight", Value: "SubmittedToFirelight" },
                { Label: "Submitted Paper Application", Value: "PaperApplication" },
                { Label: "No Suitable Product", Value: "NoSuitableProduct" },
                { Label: "Uploaded Application", Value: "UploadApplication" },
                { Label: "Inforce", Value: "Inforce" },
                { Label: "Review Completed", Value: "ReviewCompleted" }
            ]
    });

})(window.app);